import { ref } from 'vue'
import { defineStore } from 'pinia'
import { useConfigStore } from '@/stores/config'
import { useRequestsStore } from '@/stores/requests'
import { useTokenStore } from '@/stores/token'
import getRequestParams from '@/helpers/getRequestParams.js'

export const useTrackStore = defineStore('track', () => {

    const configStore       = useConfigStore()
    const requestsStore     = useRequestsStore()
    const tokenStore        = useTokenStore()

    const track            = ref([])
    const trackPart        = ref([])
    const trackProcess     = ref(false)
    const trackMsg         = ref({})

    const trackODM         = ref(null)
    const trackODMProcess  = ref(false)
    const trackODMMsg      = ref({})

    async function readTrack(payload) {

        trackProcess.value = true
        const token = tokenStore.access

        if(token) { 

            let params = ''

            if(payload) {
                for( let param in payload) {
                    if(Array.isArray(payload[param])) {
                        payload[param].map( el => {
                            params.length ?
                                params += '&' + param + '=' + el :
                                params = '?' + param + '=' + el
                        })
                    } else {
                        params.length ?
                            params += '&' + param + '=' + payload[param] :
                            params = '?' + param + '=' + payload[param]
                    }
                }
            }

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/cars/points/track${params}`, 
                method: 'GET', 
                token
            })

            if(!request.error) {
                trackPart.value.push(...request.array)
                if(request.c.isAfter) {
                    payload['c.direction'] = 'after'
                    payload['c.cursor'] = request.c.stop
                    payload['c.limit'] = 1000
                    await readTrack(payload)
                    return true
                } else {
                    track.value = trackPart.value
                    trackPart.value = []
                    trackMsg.value = { success: true }
                }
            } else {
                track.value = []
                trackMsg.value = { success: false, text: request.error }
            }

        } else {
            trackMsg.value = { success: false, text: 'EToken' }
        }

        trackProcess.value = false
        return track.value
    }

    async function readMileage(payload) {

        const token = tokenStore.access

        if(token) {
            trackODMProcess.value = true

            let params = getRequestParams(payload)

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/cars/points/mileage${params}`, 
                method: 'GET', 
                token
            })

            if(!request.error) {
                trackODM.value = Number(request).toFixed(1)
                trackODMMsg.value = { success: true }
            } else {
                trackODM.value = null
                trackODMMsg.value = { success: false, text: request.error }
            }

            trackODMProcess.value = false

        } else {
            trackODMMsg.value = { success: false, text: 'EToken' }
        }
    }

    const setTrack      = data => track.value = data
    const setTrackMsg   = data => trackMsg.value = data

    const setTrackODM      = data => trackODM.value = data
    const setTrackODMMsg   = data => trackODMMsg.value = data

    return {

        track, 
        trackProcess, 
        trackMsg, 
        trackODM, 
        trackODMProcess, 
        trackODMMsg, 
        readTrack,
        readMileage,
        setTrack, 
        setTrackMsg,
        setTrackODM,
        setTrackODMMsg
    }
})
